import { enumLanguage } from "@/constants";

// 获取当前系统语言
export const getSystemLanguage = function () {
    const data = localStorage.getItem("userMsg") || "{}";
    const userMsg = JSON.parse(data);
    return userMsg.systemLanguage || enumLanguage["中文简体"];
};

// 防抖
export const debounce = function (func, delay, immediate = false) {
    let timer;
    let isInvoke = false;
    return function (...args) {
        if (timer) {
            clearTimeout(timer);
        }

        if (immediate && !isInvoke) {
            func.apply(this, args);
            isInvoke = true;
        } else {
            timer = setTimeout(() => {
                func.apply(this, args);
                isInvoke = false;
            }, delay);
        }
    };
};

// 按十进制文本截断分数，避免 JS 浮点乘法导致 -1.13 变 -1.12 这类问题。
export const truncateScore = function (score, decimalPlace) {
    const numericScore = Number(score);
    if (!Number.isFinite(numericScore)) {
        return score;
    }

    const dp = Math.max(0, Number(decimalPlace) || 0);
    const scoreText = String(score);

    if (scoreText.toLowerCase().includes("e")) {
        const factor = Math.pow(10, dp);
        const truncated =
            (numericScore < 0 ? Math.ceil(numericScore * factor) : Math.floor(numericScore * factor)) / factor;
        return Object.is(truncated, -0) ? 0 : truncated;
    }

    const isNegative = scoreText.startsWith("-");
    const unsignedText = isNegative ? scoreText.slice(1) : scoreText;
    const [integerPart = "0", fractionPart = ""] = unsignedText.split(".");
    const normalizedIntegerPart = integerPart || "0";
    const sign = isNegative ? "-" : "";

    if (dp === 0 || !fractionPart) {
        const truncated = Number(`${sign}${normalizedIntegerPart}`);
        return Object.is(truncated, -0) ? 0 : truncated;
    }

    const truncatedFraction = fractionPart.slice(0, dp);
    const truncatedText = truncatedFraction
        ? `${sign}${normalizedIntegerPart}.${truncatedFraction}`
        : `${sign}${normalizedIntegerPart}`;
    const truncated = Number(truncatedText);
    return Object.is(truncated, -0) ? 0 : truncated;
};

// 获取清理后的URL（保留路径查询参数，去除hash中的查询参数）
export const getCleanUrl = function () {
    const { origin, pathname, search, hash } = window.location;
    
    // 保留路径和路径查询参数
    let url = origin + pathname + search;
    
    // 如果有hash，只保留hash路径部分，去掉hash中的查询参数
    if (hash) {
        const hashPath = hash.split('?')[0];
        url += hashPath;
    }
    
    return url;
};
